import { name } from 'jssip'

const state = {
  agentSessions: [],
  activeSessionId: null,
  queuesSummary: [],
  autoPickUp: true,
  customerInfo: [],
  agentInfo: [],
  uiStateChat: [],
  queuesType: [],
  voiceSessions: [],
  voiceQueuesSummary: [],
  activeLiveCallSessionId: null,
  liveCallCustomerInfo: [],
  isCurrentInCall: false,
  timerBegan: null,
  uiMode: null,
  webRtcSession: null
}

const mutations = {
  // START LIVE CALL AGENT MUTATION SECTION //

  setLiveCallCustomerInfo(state, customerInfo) {
    state.liveCallCustomerInfo = customerInfo
  },

  setVoiceQueuesSummary(state, voiceQueuesSummary) {
    state.voiceQueuesSummary = voiceQueuesSummary
  },

  updateVoiceQueuesSummary(state, voiceQueueSummary) {
    voiceQueueSummary.forEach(
      element =>
        (state.voiceQueuesSummary = state.voiceQueuesSummary.map(obj =>
          obj.queue_id === element.queue_id
            ? {
                ...obj,
                count: element.count,
                longest_date: element.longest_date
              }
            : obj
        ))
    )
  },

  setLiveCallAgentSessions(state, sessionId) {
    state.voiceSessions = state.voiceSessions.map(obj =>
      obj.session_id == sessionId
        ? {
            ...obj,
            is_live: true
          }
        : obj
    )
  },

  setActiveLiveCallSession(state, id) {
    state.activeLiveCallSessionId = id
  },
  clearLiveCallActiveSession(state) {
    state.activeLiveCallSessionId = null
  },
  setIsCurrentInCall(state, value) {
    state.isCurrentInCall = value
  },

  setTimerBegan(state, value) {
    state.timerBegan = value
  },

  //จะส่งค่า true เพื่อเรียก voice page
  setVoiceSessions(state, voiceSessions) {
    state.voiceSessions = voiceSessions
  },

  setQueuesType(state, queuesType) {
    state.queuesType = queuesType
  },

  removeLiveCallAgentSession(state, sessionId) {
    state.agentSessions = state.agentSessions.filter(
      item => item.session_id != sessionId
    )
  },

  addLiveCallAgentSession(state, agentSession) {
    // TODO: Pock: อยากจะเปลี่ยนมาใช่ Filter แทน

    state.voiceSessions = agentSession
    // const index = state.voiceSessions.findIndex(
    //   s => s.session_id == agentSession.session_id
    // )
    // if (index < 0) {
    //   state.voiceSessions.unshift(agentSession)
    // }
  },

  setUiMode(state, value) {
    state.uiMode = value
  },

  setWebRtcSession(state, value) {
    state.webRtcSession = value
  },

  // END LIVE CALL AGENT MUTATION SECTION //

  resetUiState(state) {
    state.uiStateChat = []
  },
  setUiState(
    state,
    { customerId, messageInputState = null, customerNoteState = null }
  ) {
    if (!state.uiStateChat[customerId]) {
      // initial object
      state.uiStateChat[customerId] = {}
    }
    if (messageInputState !== null) {
      state.uiStateChat[customerId].messageInputState = messageInputState
    }
    if (customerNoteState !== null) {
      state.uiStateChat[customerId].customerNoteState = customerNoteState
    }
  },
  resetCustomerInfo(state) {
    state.customerInfo = []
  },
  setCustomerInfo(
    state,
    { customerId, firstContactData, lastContactData, customerNote }
  ) {
    if (!state.customerInfo[customerId]) {
      // initial object
      state.customerInfo[customerId] = {}
    }

    if (firstContactData) {
      state.customerInfo[customerId].firstContactData = firstContactData
    }
    if (lastContactData) {
      state.customerInfo[customerId].lastContactData = lastContactData
    }
    if (customerNote) {
      state.customerInfo[customerId].customerNote = customerNote
    }
  },
  resetAgentInfo(state) {
    state.agentInfo = []
  },
  setAgentInfo(state, { agentId, avatar }) {
    if (!state.agentInfo[agentId]) {
      // initial object
      state.agentInfo[agentId] = {}
    }
    if (avatar) {
      state.agentInfo[agentId].avatar = avatar
    }
  },
  setAutoPickUp(state, value) {
    state.autoPickUp = value
  },
  resetLiveAgentSession(state) {
    state.agentSessions.forEach(session => {
      session.is_live = false
    })
  },
  setLiveAgentSessions(state, sessionId) {
    state.agentSessions = state.agentSessions.map(obj =>
      obj.session_id == sessionId
        ? {
            ...obj,
            is_live: true
          }
        : obj
    )
  },
  setAgentSessions(state, agentSessions) {
    state.agentSessions = agentSessions
  },
  addAgentSession(state, agentSession) {
    // TODO: Pock: อยากจะเปลี่ยนมาใช่ Filter แทน
    const index = state.agentSessions.findIndex(
      s => s.session_id == agentSession.session_id
    )
    if (index < 0) {
      state.agentSessions.unshift(agentSession)
    }
  },
  removeAgentSession(state, sessionId) {
    state.agentSessions = state.agentSessions.filter(
      item => item.session_id != sessionId
    )
  },
  setActiveSession(state, id) {
    state.activeSessionId = id
  },
  clearActiveSession(state) {
    state.activeSessionId = null
  },
  addMessages(state, { sessionId, messages, unread }) {
    // TODO: Pock: อยากจะเปลี่ยนมาใช่ Filter แทน
    let index = state.agentSessions.findIndex(s => s.session_id == sessionId)
    if (index >= 0) {
      if (messages && messages.length > 0) {
        state.agentSessions[index].messages.push(...messages)
      }
      state.agentSessions[index].unread = unread

      // ถ้าเป็นการ chat มาจากฝั่ง Agent ก็ไม่ต้อง sort, ให้เอา message ต่อท้ายไปเลย
      const skipSorting = ((messages.length == 1) && (messages[0].sender == 'agent'))? true: false
      if (!skipSorting) {
        // sort messages by created_at
        state.agentSessions[index].messages.sort((a, b) => {
          const fa = new Date(a.created_at)
          const fb = new Date(b.created_at)
          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }
          return 0
        })
      }
    }
  },

  removeMessageByDeliverId(state, { sessionId, deliverId }) {
    const session = state.agentSessions.filter(
      item => item.session_id == sessionId
    )

    if (session && session.length > 0) {
      const removed = session[0].messages.filter(
        m =>
          !m.message.deliver ||
          (m.message.deliver && m.message.deliver.id !== deliverId)
      )

      state.agentSessions = state.agentSessions.map(obj =>
        obj.session_id == sessionId
          ? {
              ...obj,
              messages: removed
            }
          : obj
      )
    }
  },

  // clearMessageDeliver(state, { sessionId, deliverId }) {
  //   const session = (state.agentSessions = state.agentSessions.filter(
  //     item => item.session_id == sessionId
  //   ))

  //   if (session && session.length > 0) {

  //     console.log('clearMessageDeliver/1', session[0].messages)
  //     const newMessages = session[0].messages.map(m =>
  //       m.message.deliver && m.message.deliver.id === deliverId
  //         ? {
  //             ...m,
  //             deliver: null
  //           }
  //         : m
  //     )
  //     console.log('clearMessageDeliver/2', newMessages)

  //     state.agentSessions = state.agentSessions.map(obj =>
  //       obj.session_id == sessionId
  //         ? {
  //             ...obj,
  //             messages: newMessages
  //           }
  //         : obj
  //     )
  //   }
  // },

  setQueuesSummary(state, queuesSummary) {
    state.queuesSummary = queuesSummary
  },
  updateQueuesSummary(state, queueSummary) {
    queueSummary.forEach(
      element =>
        (state.queuesSummary = state.queuesSummary.map(obj =>
          obj.queue_id === element.queue_id
            ? {
                ...obj,
                count: element.count,
                longest_date: element.longest_date
              }
            : obj
        ))
    )
  },
  resetUnreadCounter(state, sessionId) {
    state.agentSessions = state.agentSessions.map(obj =>
      obj.session_id == sessionId
        ? {
            ...obj,
            unread: {
              ...obj.unread,
              count: 0
            }
          }
        : obj
    )
  },
  resetFirstUnreadId(state, sessionId) {
    state.agentSessions = state.agentSessions.map(obj =>
      obj.session_id == sessionId
        ? {
            ...obj,
            unread: {
              ...obj.unread,
              first_unread_id: null
            }
          }
        : obj
    )
  }
}

//
const actions = {
  resetUiState({ commit }) {
    commit('resetUiState')
  },
  setUiState({ commit }, { customerId, messageInputState, customerNoteState }) {
    commit('setUiState', { customerId, messageInputState, customerNoteState })
  },
  resetCustomerInfo({ commit }) {
    commit('resetCustomerInfo')
  },
  setCustomerInfo(
    { commit },
    { customerId, firstContactData, lastContactData, customerNote }
  ) {
    commit('setCustomerInfo', {
      customerId: customerId,
      firstContactData: firstContactData,
      lastContactData: lastContactData,
      customerNote: customerNote
    })
  },
  resetAgentInfo({ commit }) {
    commit('resetAgentInfo')
  },
  setAgentInfo({ commit }, { agentId, avatar }) {
    commit('setAgentInfo', { agentId, avatar })
  },
  setAutoPickUp({ commit }, value) {
    commit('setAutoPickUp', value)
  },
  resetLiveAgentSession({ commit }) {
    commit('resetLiveAgentSession')
  },
  setLiveAgentSessions({ commit }, sessionId) {
    commit('setLiveAgentSessions', sessionId)
  },
  setAgentSessions({ commit, state }, agentSessions) {
    commit('setAgentSessions', agentSessions)

    if (!agentSessions.some(s => s.session_id == state.activeSessionId)) {
      commit('clearActiveSession')
    } else {
      commit('resetUnreadCounter', state.activeSessionId)
    }
  },
  addAgentSession({ commit }, agentSession) {
    commit('addAgentSession', agentSession)
    // console.log('add agentSession ==> ', agentSession)
  },
  removeAgentSession({ commit }, sessionId) {
    commit('removeAgentSession', sessionId)
  },
  setActiveSession({ commit }, id) {
    commit('setActiveSession', id)
  },
  clearActiveSession({ commit }) {
    commit('clearActiveSession')
  },
  addMessages(
    { commit, state },
    { sessionId, messages, unread, freezeList = false }
  ) {
    commit('addMessages', { sessionId, messages, unread })

    if (messages && messages.length && !freezeList) {
      // move this session to first of the array(it's means top of the list)
      const session = state.agentSessions.filter(
        item => item.session_id == sessionId
      )
      if (session.length >= 1) {
        commit('removeAgentSession', sessionId)
        commit('addAgentSession', session[0])
      }
    }
  },
  removeMessageByDeliverId({ commit, state }, { sessionId, deliverId }) {
    commit('removeMessageByDeliverId', { sessionId, deliverId })
  },
  /*
  clearMessageDeliver({ commit, state }, { sessionId, deliverId }) {
    commit('clearMessageDeliver', { sessionId, deliverId })
  },
  */
  setQueuesSummary({ commit }, queuesSummary) {
    commit('setQueuesSummary', queuesSummary)
  },
  updateQueuesSummary({ commit }, queueSummary) {
    commit('updateQueuesSummary', queueSummary)
  },
  resetUnreadCounter({ commit }, sessionId) {
    commit('resetUnreadCounter', sessionId)
  },
  resetFirstUnreadId({ commit }, sessionId) {
    commit('resetFirstUnreadId', sessionId)
  },

  // START LIVE CALL AGENT ACTION SECTION //

  setVoiceQueuesSummary({ commit }, voiceQueuesSummary) {
    commit('setVoiceQueuesSummary', voiceQueuesSummary)
  },
  updateVoiceQueuesSummary({ commit }, voiceQueueSummary) {
    commit('updateVoiceQueuesSummary', voiceQueueSummary)
  },

  setLiveCallAgentSessions({ commit }, sessionId) {
    commit('setLiveCallAgentSessions', sessionId)
  },
  setActiveLiveCallSession({ commit }, id) {
    commit('setActiveLiveCallSession', id)
  },
  clearLiveCallActiveSession({ commit }) {
    commit('clearLiveCallActiveSession')
  },
  setIsCurrentInCall({ commit }, value) {
    commit('setIsCurrentInCall', value)
  },
  setTimerBegan({ commit }, value) {
    commit('setTimerBegan', value)
  },
  setUiMode({ commit }, value) {
    commit('setUiMode', value)
  },
  setWebRtcSession({ commit }, value) {
    commit('setWebRtcSession', value)
  },
  removeLiveCallAgentSession({ commit }, sessionId) {
    commit('removeLiveCallAgentSession', sessionId)
  },
  setLiveCallCustomerInfo({ commit }, customerInfo) {
    commit('setLiveCallCustomerInfo', customerInfo)
  },
  setQueuesType({ commit }, queuesType) {
    commit('setQueuesType', queuesType)
  },
  removeLiveCallAgentSession({ commit }, sessionId) {
    commit('removeLiveCallAgentSession', sessionId)
  },
  addLiveCallAgentSession({ commit }, agentSession) {
    commit('addLiveCallAgentSession', agentSession)
    // console.log('add agentSession ==> ', agentSession)
  },
  setVoiceSessions({ commit, state }, agentSessions) {
    commit('setVoiceSessions', agentSessions)

    if (
      !agentSessions.some(s => s.session_id == state.activeLiveCallSessionId)
    ) {
      commit('clearActiveSession')
    } else {
      commit('resetUnreadCounter', state.activeLiveCallSessionId)
    }
  }

  // END LIVE CALL AGENT ACTION SECTION //
}

//
export const agent = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters: {
    agentSessions: state => state.agentSessions,
    agentSession: state => sessionId =>
      state.agentSessions.find(s => s.session_id == sessionId),
    activeSessionId: state => state.activeSessionId,
    queuesSummary: state => state.queuesSummary,
    autoPickUp: state => (state.autoPickUp ? true : false),
    customerInfo: state => state.customerInfo,
    agentInfo: state => state.agentInfo,
    uiStateChat: state => state.uiStateChat,
    queuesType: state => state.queuesType,
    voiceSessions: state => state.voiceSessions,
    voiceQueuesSummary: state => state.voiceQueuesSummary,
    activeLiveCallSessionId: state => state.activeLiveCallSessionId,
    liveCallCustomerInfo: state => state.liveCallCustomerInfo,
    isCurrentInCall: state => state.isCurrentInCall,
    voiceAgentSessions: state => state.voiceAgentSessions,
    voiceSession: state => state.voiceSessions,
    timerBegan: state => state.timerBegan,
    uiMode: state => state.uiMode,
    webRtcSession: state => state.webRtcSession
  }
}
